import CtaBanking from "../components/Bank/CtaBanking";
import HowItWorksBanking from "../components/Bank/HowItWorksBanking";
import CtaEcomm from "../components/Ecomm/CtaEcomm";
import HowItWorksEcomm from "../components/Ecomm/HowItWorksEcomm";
import Header from "../components/Header";

export default function Landing() {
    const isBank = process.env.REACT_APP_APP_TYPE === 'Bank';

    return (
        <div>
            <Header />
            {isBank ? <CtaBanking /> : <CtaEcomm />}
            {isBank ? <HowItWorksBanking /> : <HowItWorksEcomm />}
        </div>
    )
}